import { useSelector, shallowEqual } from "react-redux";

export function RoleChecker(action, subject) {
  const { access } = useSelector(
    state => ({ access: state.auth.user.access_role.access }),
    shallowEqual
  );
  const accessRole = access.filter(item => {
    if (
      item.subject === subject &&
      item.action === action &&
      item.inverted !== true
    ) {
      return item;
    }
  });

  return accessRole.length > 0;
}

export function RoleCheckerNoRedux(action, subject, access) {
  let accessRole = access.filter(item => {
    if (
      item.subject === subject &&
      item.action === action &&
      item.inverted !== true
    ) {
      return item;
    }
  });
  return accessRole.length > 0;
}

export const BlockOrg = () => {
  const {
    currentState: {
      user: { organization }
    }
  } = useSelector(state => ({ currentState: state.auth }), shallowEqual);

  return organization.status !== "BLOCK";
};

export const DisableFeature = (blacklistOrganizationFeature = [], feature) => {
  const blacklistFeature = blacklistOrganizationFeature.filter(
    bf => bf.feature_blacklist === feature
  );
  return !blacklistFeature.length > 0;
};
